<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1300px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    maxlength="64"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="工资条数"
                  prop="infoCount"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.infoCount"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="应发总金额"
                  prop="payableTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.payableTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="实发总金额"
                  prop="paymentTotal"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.paymentTotal"
                    disabled
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            人员工资明细
            <el-button
              v-if="eventType !== 'view'"
              type="success"
              size="mini"
              style="float:right; margin-top:0.1em; margin-right:15px;"
              @click="handleAddItem"
            >
              添加工资
            </el-button>
          </h3>
          <div class="modal-row-box">
            <el-row
              :gutter="10"
              style="margin-bottom:10px;"
            >
              <el-col :span="24">
                <el-table
                  :data="infoListData"
                  class="public-table"
                  :header-cell-style="{background:'#0076ff'}"
                  style="width: 100%"
                  border
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                  />
                  <el-table-column
                    prop="employeeName"
                    label="人员名称"
                    align="center"
                  />
                  <el-table-column
                    prop="schemeNo"
                    label="方案编号"
                    align="center"
                  />
                  <el-table-column
                    prop="sellId"
                    label="活动编号"
                    width="100"
                    align="center"
                  />
                  <el-table-column
                    prop="activityDate"
                    label="活动日期"
                    width="140"
                    align="center"
                  />
                  <el-table-column
                    prop="payableAmount"
                    label="应发金额"
                    width="140"
                    header-align="center"
                    align="right"
                  />
                  <el-table-column
                    label="实发金额"
                    width="140"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.paymentAmount"
                        :disabled="eventType === 'view'"
                        @input="(val)=>{limitPositiveNumber(val, scope.row, 'paymentAmount')}"
                        @blur="setNumberValueDefaultZero($event, scope.row, 'paymentAmount',2);totalItemAmountFun()"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="eventType !== 'view'"
                    label="操作"
                    width="60"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        content="删除"
                        placement="top"
                      >
                        <i
                          class="el-icon-delete"
                          style="color: red; font-size: 14px;"
                          @click="handleDeleteItem(infoListData, scope.$index); totalItemAmountFun()"
                        />
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 绩效列表 -->
    <info-list-dialog
      :dialog-visible.sync="dialogInfoVisible"
      dialog-title="活动报告外聘人员工资信息"
      @selectedInfoFun="selectedInfoFun"
    />
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择工资
import infoListDialog from './infoListDialog'
// API
import { viewSalaryExternalEmployeeSalaryBillApi, saveSalaryExternalEmployeeSalaryBillApi } from '@/api/v2/salaryExternalEmployeeSalaryBill'

export default {
  components: {infoListDialog},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      dialogInfoVisible: false,
      infoListData: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.infoListData = []

        _this.dialogAddEditViewForm = {
          name: '',
          infoCount: 0,
          payableTotal: 0,
          paymentTotal: 0,
          remark: ''
        }
        if (_this.eventType !== 'add') {
          _this.loadSalaryExternalEmployeeSalaryBillData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSalaryExternalEmployeeSalaryBillData () {
      let _this = this
      viewSalaryExternalEmployeeSalaryBillApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        this.infoListData = data.infoDtoList
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    //添加绩效
    handleAddItem () {
      let _this = this;
      _this.dialogInfoVisible = !_this.dialogInfoVisible
    },
    //添加绩效回调
    selectedInfoFun (selectList) {
      let _this = this;
      selectList.forEach(item => {
        let isHas = false
        _this.infoListData.forEach(listItem => {
          if (listItem.id === item.id) {
            isHas = true
          }
        })
        if (!isHas) {
          _this.infoListData.push(item)
        }
      })
      _this.totalItemAmountFun()
    },
    //计算合计
    totalItemAmountFun(){
      let _this = this;
      _this.dialogAddEditViewForm.infoCount = _this.infoListData.length
      let payableTotal = 0
      let paymentTotal = 0
      _this.infoListData.forEach(item => {
        payableTotal = Number((payableTotal + Number(item.payableAmount)).toFixed(2))
        paymentTotal = Number((paymentTotal + Number(item.paymentAmount)).toFixed(2))
      })
      _this.dialogAddEditViewForm.payableTotal = payableTotal
      _this.dialogAddEditViewForm.paymentTotal = paymentTotal
    },
    handleDeleteItem(listData, index){
      let _this = this
      let selectItem = listData[index]
      _this.$confirm('是否删除 方案编号【'+ selectItem.schemeNo + "】活动编号【" + selectItem.sellId + "】人员名称【" + selectItem.employeeName + '】活动日期【' + selectItem.activityDate + "】的工资信息？", '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        listData.splice(index, 1)
        _this.totalItemAmountFun()
      }).catch(() => { })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      if(_this.infoListData.length === 0){
        _this.$message({ message: '请选择人员工资', type: 'warning' })
        return false
      }
      _this.dialogAddEditViewForm.jsonInfoData = JSON.stringify(_this.infoListData)
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '活动报告外聘人员工资发放管理', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {

            saveSalaryExternalEmployeeSalaryBillApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
